import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import avatarPro from "assets/img/Share-Safari/dpinterested.png";
import { useState } from "react";
import { apiCall2 } from "components/Api/api";
import { useAuth } from "provider/AuthContext";
import { handleError } from "components/Api/handleError";

function InterestesUserModal() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { instUserToggle, safariViewData, intreastedUsers, summaryInstUser,
    pageIndexInstUser, sharedSafariDispatch } =
    useSharedSafariContext();


  const [loading, setLoading] = useState(false);


  const handleClose = () => {
    sharedSafariDispatch({
      type: "SET_SHARED_SAFARI_VIEW_USERS_TOGGLE",
      payload: false,
    });
  };

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formatted = date.toLocaleString("en-US", options);

    const [monthDay, year, time] = formatted.replace(",", "").split(" ");
    return `${monthDay} ${year}, ${time.replace(",", "")}`.replace("AM", "AM").replace("PM", "PM").replace(",", "");
  }

  const fetchAllComments = async (nextPage) => {
    try {
      setLoading(true);
      const response = await apiCall2({ url: `${safariViewData?.urls?.intrested_users}?page=${nextPage}&pageSize=10`, method: "GET" });
      if (response.status !== 200) throw new Error(`Unexpected status: ${response.status}`);

      const data = response.data.intrested_users?.data || [];
      const summary = response?.data?.intrested_users?.summary;


      sharedSafariDispatch({
        type: "APPEND_INTRESTED_USERS_DATA",
        payload: data,
      });


      sharedSafariDispatch({
        type: "SF_INTRESTER_USER_SUMMARY",
        payload: {
          total: summary.total,
          page: summary.page,
          pageSize: summary.pageSize,
          total_page: summary.total_page,
        },
      });
    } catch (error) {
      handleError(error, logout, navigate);
    } finally {
      setLoading(false)
    }
  };

  return (
    <Modal show={instUserToggle} size="xl" onHide={handleClose} centered dialogClassName="modal-fixed-header-footer">
      <Modal.Header className="p-2 modal-header-fixed">
        <h2 className="modal-title fs-5" id="exampleModalLabel">
          Interested
        </h2>
        <button
          onClick={handleClose}
          className="bg-transparent"
          style={{
            border: "none",
            color: "#fff",
            fontSize: "26px",
            fontWeight: "900",
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      <Modal.Body className="modal-body-scroll">
        <div className="grid-view">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Join At</th>
              </tr>
            </thead>
            <tbody>
              {intreastedUsers?.map((user, index) => (
                <tr key={user.id}>
                  <td style={{ width: "10%" }}>{index + 1}</td>
                  <td>
                    <Link
                      to={`/profile/default/index?user_handle=${user.user_handle}`}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <Image
                          src={user?.profile_display_image || avatarPro}
                          alt="user"
                          className="rounded-circle bg-secondary"
                          width={30}
                          height={30}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = avatarPro;
                          }}
                        />
                        {user.name || "Unknown User"}
                      </div>
                    </Link>
                  </td>

                  <td style={{ width: "20%" }}>
                    {/* {user.joined_at
                      ? new Date(user.created_at).toLocaleDateString()
                      : "N/A"} */}
                    {user.joined_at
                      ? formatTimestamp(user.joined_at)
                      : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-center my-4">
            {loading ? (
              <div
                className="spinner-border loading-spinner"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              summaryInstUser?.page < summaryInstUser?.total_page && (
                <button
                  className="join_btn newbgjoin mt-sm-0 mt-2"
                  onClick={() => {
                    const nextPage = pageIndexInstUser + 1
                    fetchAllComments(nextPage)
                    sharedSafariDispatch({
                      type: "SF_INTRESTER_USER_PAGE_INDEX",
                      payload: nextPage,
                    });
                  }}
                  disabled={loading}
                >
                  Show More
                </button>
              )
            )}
          </div>
          <Modal.Footer className="modal-footer-fixed">
            <div className="summary w-100 text-center">
              Showing <b>1</b> - <b>{intreastedUsers.length}</b> of <b>{intreastedUsers.length}</b> interested users
            </div>
          </Modal.Footer>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default InterestesUserModal;
